import { getQaSelector } from '../../../../utils/common'
import { DragDropSortableItem } from '../../../DragDrop'
import { BIRDVIEW_DRAGGING_ITEM_STYLE } from '../../DashboardBirdview.constants'
import {
  QA_NAME_DASHBOARD_BIRDVIEW_RESIZE_COLUMN,
  QA_NAME_DASHBOARD_BIRDVIEW_RESIZE_ROW,
} from '../../DashboardBirdview.constants.qa'
import { useBirdviewChartGridResize } from '../BirdviewChartGrid.hooks'
import { getBirdviewChartGridSpanStyle } from '../BirdviewChartGrid.utils'

import * as styles from './BirdviewChartGridItem.module.css'

function BirdviewChartGridItem({
  children,
  columnSpan,
  id,
  isLocked,
  rowSpan,
  onResizeColumn,
  onResizeRow,
}) {
  const { handleColumnResizeStart, handleRowResizeStart, itemRef } =
    useBirdviewChartGridResize({
      columnSpan,
      rowSpan,
      onResizeColumn,
      onResizeRow,
    })

  return (
    <DragDropSortableItem
      withDragHandle
      className={styles.item}
      draggingStyle={BIRDVIEW_DRAGGING_ITEM_STYLE}
      id={id}
      sortableProps={{ disabled: isLocked }}
      style={getBirdviewChartGridSpanStyle({ columnSpan, rowSpan })}
    >
      {dragHandleProps => (
        <div className={styles.content} ref={itemRef}>
          {children(dragHandleProps)}
          {isLocked ? null : (
            <>
              <span
                {...getQaSelector({
                  value: QA_NAME_DASHBOARD_BIRDVIEW_RESIZE_COLUMN,
                })}
                aria-hidden
                className={styles.columnHandle}
                onPointerDown={handleColumnResizeStart}
              />
              <span
                {...getQaSelector({
                  value: QA_NAME_DASHBOARD_BIRDVIEW_RESIZE_ROW,
                })}
                aria-hidden
                className={styles.rowHandle}
                onPointerDown={handleRowResizeStart}
              />
            </>
          )}
        </div>
      )}
    </DragDropSortableItem>
  )
}

export default BirdviewChartGridItem
